import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store'
import { TraduccionesTareas } from '@/Util/TraduccionesTareas'
import { Utilidades } from '@/Util/Utilidades'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    meta: {
      redirecionar_home: true,
      traduccir: false
    },
    component: () => import('../views/Auth/Login.vue'),
  },
  {
    path: '/registrarse',
    name: 'registrarse',
    meta: {
      redirecionar_home: true,
      traduccir: false
    },
    component: () => import('../views/Auth/Registrarse.vue'),
  },
  {
    path: '/recuperar-clave',
    name: 'recuperar_clave',
    meta: {
      redirecionar_home: true,
      traduccir: false
    },
    component: () => import('../views/Auth/RecuperarClave.vue'),
  },
  {
    path: '/clave-caducada',
    name: 'clave_caducada',
    meta: {
      redirecionar_home: false,
      traduccir: false
    },
    component: () => import('../views/Auth/ClaveCaducada.vue'),
  },
  {
    path: '/usuario/activar/:token',
    name: 'usuario-activar',
    meta: {
      redirecionar_home: false,
      traduccir: false
    },
    component: () => import('../views/Auth/ActivarUsuario.vue'),
  },
  {
    path: '/aceptar/asociacion/:token',
    name: 'aceptar_asociacion',
    meta: {
      redirecionar_home: false,
      traduccir: false
    },
    component: () => import('../views/Empresas/AceptarSolicitacion.vue'),
  },
  {
    path: '/nueva-clave',
    name: 'nueva_clave',
    meta: {
      redirecionar_home: true,
      traduccir: false
    },
    component: () => import('../views/Auth/NuevaClave.vue'),
  },
  {
    path: '/link-email',
    name: 'link_email',
    meta: {
      redirecionar_home: true,
      traduccir: false
    },
    component: () => import('../views/Auth/LinkEmail.vue'),
  },
  {
    path: '/contratar-plan',
    name: "contratar_plan",
    component: () => import('../views/Auth/ContratarPlan.vue'),
    meta: {
      title: "Contratar Plan",
      traduccir: false
    },
  },
  {
    path: '/',
    name: 'Indice',
    meta: {
      traduccir: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.

    component: () => import('../views/Indice/Indice.vue'),
  },
  {
    path: '/factura/consultar/:id',
    name: 'Consultar',
    meta: {
      traduccir: false
    },
    component: () => import('../views/Factura/ConsultarFactura.vue'),
  },
  {
    path: '/facturapp',
    name: 'facturapp',
    meta: {
      authentication: true,
      traduccir: false
    },
    component: HomeView,
    children: [
      {
        path: "/home",
        name: "home",
        meta: {
          title: "Home",
          traduccir: false
        },
        component: () => import('../views/Home/Home.vue')
      },
      {
        path: "/configuracion",
        name: "configuracion",
        component: () => import('../views/Administracion/Configuracion.vue'),
        meta: {
          title: "Configuraciones",
          traduccir: false
        },
        children: [
          {
            path: "/configuracion/usuarios",
            name: "usuarios",
            component: () => import('../views/Administracion/Usuarios/AdmUsuario.vue'),
            meta: {
              title: "Usuarios",
            },
          },
          {
            path: "/configuracion/perfiles",
            name: "perfiles",
            component: () => import('../views/Administracion/Perfil/AdmPerfil.vue'),
            meta: {
              title: "Perfiles",
            },
          },
          {
            path: "/configuracion/tareas",
            name: "tareas",
            component: () => import('../views/Administracion/Tarea/AdmTarea.vue'),
            meta: {
              title: "Tarea"
            },
          },
        ]
      },
      {
        path: '/borrar/cuenta',
        name: 'borrar-cuenta',
        meta: {
          title: 'Borrar cuenta',
        },
        component: () => import('../views/Auth/BorrarCuenta.vue'),
      },
      {
        path: '/salir',
        name: 'salir',
        meta: {
          title: 'Salir',
        },
        component: () => import('../views/Auth/Salir.vue'),
      },
      {
        path: '/aplicacion/contabilidad/traertablas',
        name: 'traer-tablas-maestras',
        meta: {
          title: 'Traer tablas maestras',
        },
        component: () => import('../views/Administracion/AplicacionContabilidad/TraerTablasMaestras.vue'),
      },
      {
        path: "/traza",
        name: "traza",
        component: () => import('../views/Traza.vue'),
        meta: {
          title: "Traza",
        },
      },
      {
        path: "/encripta",
        name: "encripta",
        component: () => import('../views/Encripta.vue'),
        meta: {
          title: "Encriptación",
        },
      },
      {
        path: "/grafica",
        name: "grafica",
        component: () => import('../views/Grafica.vue'),
        meta: {
          title: "grafica",
        },
      },
      {
        path: "/postit",
        name: "postit",
        component: () => import('../views/Administracion/Postit/Postits.vue'),
        meta: {
          title: "Postit",
        },
      },
      {
        path: "/traduccion",
        name: "traduccion",
        component: () => import('../views/Traduccion/Traduccion.vue'),
        meta: {
          title: "Traducciones",
        },
        children: [
          {
            path: "/traduccion/textos",
            name: "textos",
            component: () => import('../views/Administracion/Texto/AdmTexto.vue'),
            meta: {
              title: "Texto",
            },
          },
          {
            path: "/traduccion/tablas",
            name: "tablas",
            component: () => import('../views/Administracion/TablaMaestra/AdmTablaMaestra.vue'),
            meta: {
              title: "Tabla",
            },
          },
        ]
      },
      {
        path: "/cambiar-clave",
        name: "cambiarClave",
        component: () => import('../views/Auth/CambiarClave.vue'),
        meta: {
          title: "Cambiar Clave"
        },
      },
      {
        path: "/permisos",
        name: "permisos",
        component: () => import('../views/SinPermisos.vue'),
        meta: {
          title: "Sin Permiso"
        },
      },
      {
        path: "/productos",
        name: "productos",
        component: () => import('../views/Productos/Producto.vue'),
        meta: {
          title: "Productos",
        }
      },
      {
        path: "/facturas",
        name: "facturas",
        component: () => import('../views/Factura/Index.vue'),
        meta: {
          title: "Facturas",
          traduccir: false
        },
        children: [
          {
            path: "/factura/repositorio",
            name: "repositorio",
            component: () => import('../views/Factura/Repositorio.vue'),
            meta: {
              title: "Repositorio",
            },
          },
          {
            path: "/factura/emitidas",
            name: "emitidas",
            component: () => import('../views/Factura/Emitidas.vue'),
            meta: {
              title: "Emitidas",
            },
          },
          {
            path: "/factura/recibidas",
            name: "recibidas",
            component: () => import('../views/Factura/Recibidas.vue'),
            meta: {
              title: "Recibidas",
            },
          },
        ]
      },
      {
        path: "/clientes",
        name: "clientes",
        component: () => import('../views/Clientes/Cliente.vue'),
        meta: {
          title: "Clientes",
        },
      },
      {
        path: "/presupuestos",
        name: "presupuestos",
        component: () => import('../views/Empresas/EmpresaFact.vue'),
        meta: {
          title: "Presupuestos",
        },
      },
      {
        path: "/empresas",
        name: "empresas",
        component: () => import('../views/Empresas/EmpresaFact.vue'),
        meta: {
          title: "Empresas",
        },
      },
      {
        path: "/empresa/constitucion",
        name: "empresa-constitucion",
        component: () => import('../views/Empresas/Constitucion/ConstitucionEmpresa.vue'),
        meta: {
          title: "Constitucion Empresa",
        },
      },
      {
        path: "/empresa/constitucion/prueba",
        name: "empresa-constitucion-2",
        component: () => import('../views/Empresas/Constitucion/ConstitucionEmpresaPrueba.vue'),
        meta: {
          title: "Constitucion Empresa",
        },
      },
      {
        path: "/empresa/tipo/acto",
        name: "tipo-acto",
        component: () => import('../views/Empresas/Constitucion/TipoActo/TipoActo.vue'),
        meta: {
          title: "Tipo Acto",
        },
      },
      {
        path: "/empresa/tipo/aportacion",
        name: "tipo-aportaicon",
        component: () => import('../views/Empresas/Constitucion/TipoAportacion/TipoAportacion.vue'),
        meta: {
          title: "Tipo Aportacion",
        },
      },
      {
        path: '/entidades',
        name: "entidades",
        component: () => import('../views/Administracion/Entidades.vue'),
        meta: {
          title: "Entidades",
        },
      },
      {
        path: '/cuentascontables',
        name: "cuentascontables",
        component: () => import('../views/Administracion/CuentaContable/AdmCuentaContableManual.vue'),
        meta: {
          title: "Cuentas Contables Manuais",
        },
      },      
      {
        path: '/bancos',
        name: "bancos",
        component: () => import('../views/Administracion/Banco/Index.vue'),
        meta: {
          title: "Bancos",
          traduccir: false
        },
        children: [
          {
            path: 'movimientos',
            name: "bancos-movimientos",
            component: () => import('../views/Administracion/Banco/Movimientos.vue'),
            meta: {
              title: "Movimientos",
            },
          },
          {
            path: "cuentas",
            name: "bancos-cuentas",
            component: () => import('../views/Administracion/Banco/BancoCuenta.vue'),
            meta: {
              title: "Cuentas",
            },
          },
          {
            path: 'conciliaciones/automaticas',
            name: "bancos-conciliaciones-automaticas",
            component: () => import('../views/Administracion/Banco/ConciliacionesAutomaticas.vue'),
            meta: {
              title: "Conciliaciones Automáticas",
            },
          },

        ]
      },
      {
        path: '/contabilidad',
        name: "contabilidad",
        component: () => import('../views/Contabilidad/Index.vue'),
        meta: {
          title: "Contabilidad",
          traduccir: false
        },

        children: [
          {
            path: 'movimientos',
            name: "conciliacion-movimientos",
            component: () => import('../views/Contabilidad/ConciliacionMovimiento.vue'),
            meta: {
              title: "Conciliación Movimientos",
            },
          },
          {
            path: 'facturas',
            name: "conciliacion-facturas",
            component: () => import('../views/Contabilidad/ConciliacionFacturas.vue'),
            meta: {
              title: "Conciliación Facturas",
            },
          },
        ],
      },
      {
        path: "/contabilidad/nominas",
        name: "contabilidad-nominas",
        component: () => import('@/views/Administracion/Nomina/Nomina.vue'),
        meta: {
          title: "Nominas"
        }
      },
      {
        path: "/contabilidad/modelo/documento",
        name: "contabilidad-modelo-documento",
        component: () => import('@/views/Administracion/ModeloDocumento/ModeloDocumento.vue'),
        meta: {
          title: "Modelo Documento"
        }
      },
      {
        path: "/contabilidad/amortizacion",
        name: "contabilidad-amortizacion",
        component: () => import('@/views/Administracion/Amortizacion/Amortizacion.vue'),
        meta: {
          title: "Amortización"
        }
      },
      {
        path: '/contabilidad/asientos',
        name: "contabilidad-asientos",
        component: () => import('../views/Contabilidad/Asientos.vue'),
        meta: {
          title: "Gestionar Asientos",
        },
      },
      {
        path: "/contabilidad/ivarepercutido",
        name: "contabilidad-ivarepercutido",
        component: () => import('@/views/Contabilidad/LibroIva.vue'),
        meta: {
          title: "IVA Repercutido"
        }
      },
      {
        path: "/contabilidad/ivasoportado",
        name: "contabilidad-ivasoportado",
        component: () => import('@/views/Contabilidad/LibroIva.vue'),
        meta: {
          title: "IVA Soportado"
        }
      },
      {
        path: "/administracion/plan",
        name: "plan",
        component: () => import('@/views/Administracion/Planes/Planes.vue'),
        meta: {
          title: "Planes"
        },
        children: [
          {
            path: "/administracion/planes",
            name: "planes",
            component: () => import('@/views/Administracion/Planes/PlanContratado.vue'),
            meta: {
              title: "Planes"
            }
          },
          {
            path: "/administracion/paquetes",
            name: "paquetes",
            component: () => import('@/views/Administracion/Planes/PlanContratado.vue'),
            meta: {
              title: "Paquetes"
            }
          },
          {
            path: "/administracion/plan/caracteristica",
            name: "plan-caracteristica",
            component: () => import('@/views/Administracion/Planes/PlanCaracteristica.vue'),
            meta: {
              title: "Planes Caracteristicas"
            }
          },
        ]
      },
    ]
  },
  {
    path: '/404',
    name: "404",
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: "404",
      traduccir: false
    },
  },
  /*
  {  //Ruta por defecto
    path: '*',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: "404", notFound: true, traduccir: false
    },
  }*/

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  store.commit('setLoading', true);

  if (from.meta.traduccir !== false) {
    let traduccion = Utilidades.clonarObjeto(store.state.traducciones);
    let tareas = Utilidades.clonarObjeto(store.state.tareas);
    let pagina = from.matched[from.matched.length - 1]?.path?.split("/:")[0];

    TraduccionesTareas.updateTraduccion(traduccion, pagina);
    TraduccionesTareas.updateTareasPagina(tareas, pagina)
  }

  store.commit('setPage', to);

  if (to.meta.traduccir !== false) {
    await store.dispatch('loadTareasYTraduccion');
  }

  store.commit('setLoading', false);

  let usuario = localStorage.getItem("usuario");

  if (to.matched.some(x => x.meta.notFound)) {
    next({ name: "404" });
  }

  if (to.name == 'usuario-activar') {
    localStorage.removeItem("usuario");
  }

  if (to.matched.some(x => x.meta.redirecionar_home)) {
    if (usuario === null || usuario === "undefined") {
      next();
    } else {
      next({
        path: '/home'
      })
    }
  }

  if (to.matched.some(x => x.meta.authentication)) {

    if (usuario === null || usuario === "undefined") {

      next({
        path: '/login',
        query: {
          redirect: to.path
        }
      })
    }
    else {
      next();
    }
  } else {
    next();
  }

  // if (to.matched.some(x => x.meta.tarea)) {
  //   var tareas = AuthService.getTareas();

  //   if (tareas) {
  //     if (tareas.some(x => to.meta.tarea.includes(x)))
  //       next();
  //     else
  //       next({ path: '/Permisos' })
  //   }
  //   else {
  //     next({ path: '/Permisos' })
  //   }
  // }

});

export default router
